import React from "react";
import { MDBRow, MDBCol, MDBIcon } from "mdbreact";
import { Fade } from "react-reveal";
import PublicationStyle from "./PublicationStyle.css";

const Project = (props) => {
  return (
    <Fade duration={2000} right>
      <div
        onClick={() => {
          props.focusNews(props.title);
        }}
        style={{
          borderBottom: "1px solid #e0e0e0",
          marginBottom: "1.5rem",
        }}
      >
        <MDBRow>
          <MDBCol md="1">
            <i
              className={`z-depth-1-half mb-4 fas fa-newspaper ${
                props.isActiveClass
              }`}
            />
          </MDBCol>
          <MDBCol md="10">
            <div className="d-flex justify-content-between">
              <MDBCol size="12" className="text-truncate pl-0 mb-3">
                <a
                  className={`font-weight-bold success-lighter-hover mb-3 ${
                    props.isActiveClass
                  }`}
                >
                  {props.title.replace(".html", "")}
                </a>
              </MDBCol>
              <a>
                <MDBIcon icon="angle-double-right" />
              </a>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    </Fade>
  );
};

export default Project;



// WEBPACK FOOTER //
// ./src/views/Publications/MapsProject.jsx